<template>
  <base-container 
    :class="mode" 
    mode="thinborder"
  >
    <template #header>
      <h3>Controles</h3>
    </template>
    <div>
      <base-button 
        link 
        to="/juegos/nuevojuego" 
        mode="outline"
      >
        Agregar Juego
      </base-button>
    </div>
  </base-container>
</template>

<script>
export default {
  props: {
    mode: {
      type: String,
      required: false,
      default: '' 
    }
  },
}
</script>
